var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

import { Resource } from '@rest-hooks/rest';
import glue from '../glue';
export default class ApplicationResource extends Resource {
  constructor() {
    super();
  }
  /** Perform network request and resolve with json body */


  static fetchResponse(input, init) {
    var _a;

    return __awaiter(this, void 0, void 0, function* () {
      let config = {
        headers: Object.assign({
          'Content-Type': 'application/json'
        }, init.headers)
      };

      switch ((_a = init.method) === null || _a === void 0 ? void 0 : _a.toLowerCase()) {
        case 'post':
          return yield glue.api.post(input.toString(), init.body, config);

        case 'put':
          return yield glue.api.put(input.toString(), init.body, config);

        case 'patch':
          return yield glue.api.patch(input.toString(), init.body, config);

        case 'delete':
          return yield glue.api.delete(input.toString(), config);

        case 'options':
          return yield glue.api.options(input.toString(), config);

        default:
          return yield glue.api.get(input.toString(), config);
      }
    });
  }

  static fetch(input, init) {
    return __awaiter(this, void 0, void 0, function* () {
      let response;

      try {
        response = yield this.fetchResponse(input, init);
        return response.data;
      } catch (e) {
        throw e;
      }
    });
  }

  static create() {
    const resourceList = this.list();
    return super.create().extend({
      schema: this,
      update: newResourceId => ({
        [resourceList.key({})]: function () {
          let resourceIds = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
          return [...resourceIds, newResourceId];
        }
      })
    });
  }

  static createNoUpdate() {
    return super.create();
  }

  static get urlRoot() {
    return glue.host + 'api' + this.resource;
  }

}

ApplicationResource.fetchOptionsPlugin = options => glue.authentication.authenticate(options);